import React from "react";
import "./Interest.css";
import CheckIcon from "../assets/Icons/check.svg";
import InterestIcon from "../assets/Icons/interest.svg";
import CrossIcon from "../assets/Icons/CrossIcon.svg";

import { useState, useEffect } from "react";
import InterestModal from "./Modal/InterestModal";

const Interest = ({
  interest,
  setInterest,
  comments,
  setComments,
  isBtnDisable,
  isError,
}) => {
  const [modalStatus, setModalStatus] = useState(false);
  const [isCommentsAdded, seIsCommentsAdded] = useState(true);

  console.log(isError);

  useEffect(() => {
    setInterest(interest);
  }, []);
  useEffect(() => {
    if (comments.length) {
      seIsCommentsAdded(true);
    } else {
      seIsCommentsAdded(false);
    }
  }, [comments]);

  return (
    <>
      <div
        className={`add-deal-card
        interest-card   ${isBtnDisable === true && "custom-disable-card"} ${
          interest ? "add-deal-card-filled" : ""
        }`}
        onClick={() => {
          if (isBtnDisable === false) {
            setModalStatus(true);
          }
        }}
      >
        {interest ? (
          <div className="active-status">
            <img src={CheckIcon} alt="landbook" />
          </div>
        ) : (
          isError && (
            <div className="active-status">
              <img src={CrossIcon} alt="landbook" />
            </div>
          )
        )}

        <div className="card-content">
          <img
            src={InterestIcon}
            alt="landbook"
            className="add-deal-card-icon"
          />
          <h2 className="add-deal-card-title">Interest</h2>
          <p className="deal-interest">
            Interested in{" "}
            {`${
              interest === "buy"
                ? "Buying"
                : interest === "sale"
                ? "Selling"
                : interest === "rent"
                ? "Renting"
                : "Nothing"
            }`}
          </p>
          <p className="deal-interest">
            {`${
              comments.length === 0
                ? "No comments added"
                : comments.length === 1
                ? "1 comment added"
                : comments.length > 1
                ? comments.length + " comments added"
                : ""
            }`}
          </p>
        </div>
      </div>
      <InterestModal
        {...{
          modalStatus,
          setModalStatus,
          interest,
          setInterest,
          comments,
          setComments,
        }}
      />
    </>
  );
};

export default Interest;
